module.exports = __webpack_public_path__ + "img/wallet_01_planet.5813e4d8.svg";